import { HttpContext, HttpContextToken } from '@angular/common/http';

export const AUTH_REQUIRED = new HttpContextToken<boolean>(() => true);
export const NO_AUTH_CONTEXT = new HttpContext().set(AUTH_REQUIRED, false);
